/* Kinetic Workspaces — Editorial split */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxItems = [];
  var ticking = false;
  function renderParallax() {
    ticking = false;
    var viewport = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var rect = item.frame.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > viewport + 200) return;
      // -1 (below the fold) .. 1 (above it)
      var progress = (rect.top + rect.height / 2 - viewport / 2) / (viewport / 2 + rect.height / 2);
      var shift = Math.max(-1, Math.min(1, progress)) * 7;
      item.layer.style.transform = 'translate3d(0,' + shift.toFixed(2) + '%,0)';
    });
  }
  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(renderParallax);
  }
  function boot(root) {
    (root || document).querySelectorAll('[data-kinetic-split]').forEach(function (section) {
      if (section.dataset.ksInit === 'true') return;
      section.dataset.ksInit = 'true';
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
        );
        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
      if (reduced) return;
      var layer = section.querySelector('[data-ks-parallax]');
      var frame = section.querySelector('.kinetic-split__frame');
      if (layer && frame) {
        parallaxItems.push({ layer: layer, frame: frame });
      }
    });
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (document.readyState !== 'loading') {
    boot(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    parallaxItems = parallaxItems.filter(function (item) {
      return document.body.contains(item.frame);
    });
  });
})();
